import axios from 'axios'
const getBaseURL = () => {
    return 'https://api.novakidschool.com/api/0/'
}
const axiosInstance = axios.create({
    baseURL: getBaseURL(),
    timeout: 200000,
    headers: {
        common: {},
        'Content-Type': 'application/json'
    }
})
export default axiosInstance
